import React from 'react'

function WidgetPlaceholder() {
  return <div className="bg-charcoal-50 text-charcoal-50 mt-5 w-auto h-48" />
}

export default WidgetPlaceholder
